import type { Card, Maybe } from 'src/types';

import { useRetryActionStore } from './RetryActionProvider';
import type { RetryAction } from './types';

export const useRetryAction = (card: Card): RetryAction | null => {
  const { state } = useRetryActionStore();
  const nextRoleRetryAction = useNextRoleRetryAction();

  if (card === 'next-role') {
    return nextRoleRetryAction;
  }

  if (card in state) {
    return state[card];
  }

  return null;
};

export const useNextRoleRetryAction = (): Maybe<RetryAction> => {
  const { state } = useRetryActionStore();
  const nextRoleRetryActionKeys = Object.keys(state).filter((key) =>
    key.startsWith('next-role'),
  );

  const action = () => {
    nextRoleRetryActionKeys.forEach((key) => {
      state[key].action();
    });
  };

  const canRetry = nextRoleRetryActionKeys.some((key) => state[key].canRetry);

  if (nextRoleRetryActionKeys.length === 0) {
    return null;
  }

  return { action, canRetry };
};
